import { SnCitizenIncidentDetails } from './citizen-incident-details';
import { SnCitizenVideoStream } from './citizen-video-stream';

/**
 * Represents details of an incident associated with a video stream.
 */
export class SnCitizenIncident extends SnCitizenIncidentDetails {
  /** Information about the incident associated with this video. */
  public videoStreams?: SnCitizenVideoStream[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
